<template>
  <el-select
    v-model="value"
    clearable
    size="large"
    filterable
    placeholder="Select branch"
    class="w-100"
  >
    <el-option
      v-for="item in branches"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "BranchesDropdown",
  data() {
    return {
      value: ""
    };
  },
  methods: {
    ...mapActions("ListsModule", ["fetchBranches"]),
    populate(id) {
      this.value = id;
    }
  },
  mounted() {
    this.fetchBranches();
  },
  computed: {
    ...mapGetters("ListsModule", ["branches"])
  }
});
</script>
